/**
 * Dental + Multivitamin Replo buybox:
 * show the same unit Shopify will charge, times "Number of dogs".
 *
 * Replo hardcodes $44.99 and leaves the Subscribe price slot empty.
 * Cart uses variant + selling_plan (e.g. 1-pack $39.99, Subscribe $29.99).
 */
(() => {
  if (window.__bwDentalDogsPriceInit) return;
  window.__bwDentalDogsPriceInit = true;

  const QTY_DISPLAY_RID = '7d608886-b948-4873-a663-0967e71588bb';
  const requestedHandles = {};

  function pricesMap() {
    return (window.BW_VARIANT_PRICES = window.BW_VARIANT_PRICES || {});
  }

  function formatMoney(n) {
    return '$' + Number(n).toFixed(2);
  }

  function looksLikeMoney(text) {
    return /^\$[\d,]+\.\d{2}$/.test(String(text).trim());
  }

  function getBuyBox() {
    return (
      Array.from(document.querySelectorAll('[data-alchemy-url-hashmark="buy box"]')).find((bb) =>
        bb.querySelector('[data-replo-increase-product-quantity], [data-replo-decrease-product-quantity]')
      ) || null
    );
  }

  function getQty(buyBox) {
    const display = buyBox.querySelector(`[data-rid="${QTY_DISPLAY_RID}"]`);
    const fromDisplay = parseInt((display?.textContent || '').trim(), 10);
    if (fromDisplay > 0) return fromDisplay;

    const input = buyBox.querySelector('input[name="quantity"]');
    const fromInput = parseInt(input?.value || '1', 10);
    return fromInput > 0 ? fromInput : 1;
  }

  function syncQtyInputs(buyBox, qty) {
    buyBox.querySelectorAll('input[name="quantity"]').forEach((input) => {
      if (input.closest('.snippit-wrapper')) return;
      if (String(input.value) !== String(qty)) input.value = String(qty);
    });
  }

  function isStrikethrough(el) {
    try {
      return (getComputedStyle(el).textDecorationLine || '').includes('line-through');
    } catch (_) {
      return false;
    }
  }

  function tabKind(el) {
    const tab = el.closest('[role="tab"]');
    if (!tab) return 'other';
    const text = tab.textContent || '';
    if (/Subscribe/i.test(text)) return 'subscribe';
    if (/One[\s-]?Time/i.test(text)) return 'onetime';
    return 'other';
  }

  function isEmptyPriceSlot(el) {
    if ((el.textContent || '').trim()) return false;
    if (!el.closest('[role="option"]')) return false;
    if (el.matches('p')) return true;
    return el.matches('span') && el.closest('.alchemy-rte');
  }

  function getPriceElements(buyBox) {
    return Array.from(buyBox.querySelectorAll('p, span')).filter((el) => {
      if (el.closest('.snippit-wrapper')) return false;
      if (el.children.length > 0) return false;
      const text = (el.textContent || '').trim();
      return looksLikeMoney(text) || /e[+-]?\d+/i.test(text) || isEmptyPriceSlot(el);
    });
  }

  function readForm(container) {
    if (!container) return null;
    const form = container.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    const idInput = form.querySelector('input[name="id"]');
    const planInput = form.querySelector('input[name="selling_plan"]');
    const variantId = idInput && idInput.value ? idInput.value : '';
    if (!variantId) return null;
    return {
      variantId,
      sellingPlanId: planInput && planInput.value ? String(planInput.value) : '',
      handle: container.getAttribute('data-replo-product-handle') || '',
    };
  }

  function firstPlanCents(data) {
    if (!data || !data.plans) return null;
    const values = Object.keys(data.plans).map((key) => data.plans[key]);
    const cents = values.find((n) => typeof n === 'number' && n > 0);
    return typeof cents === 'number' ? cents : null;
  }

  function unitsFromContainer(container) {
    const ctx = readForm(container);
    if (!ctx) return null;

    const data = pricesMap()[ctx.variantId];
    if (!data) {
      loadHandle(ctx.handle);
      return null;
    }

    const oneTime = data.priceCents / 100;
    let subscribeCents =
      ctx.sellingPlanId && data.plans && typeof data.plans[ctx.sellingPlanId] === 'number'
        ? data.plans[ctx.sellingPlanId]
        : firstPlanCents(data);
    const subscribe = typeof subscribeCents === 'number' ? subscribeCents / 100 : oneTime;

    return { onetime: oneTime, subscribe };
  }

  function classify(el) {
    if (isStrikethrough(el)) return 'was';

    const option = el.closest('[role="option"]');
    const kind = tabKind(el);

    if (kind === 'onetime') return 'onetime';

    if (kind === 'subscribe') {
      if (isEmptyPriceSlot(el)) return 'subscribe';
      if (option && option.getAttribute('aria-selected') === 'false') return 'was';
      if (option && option.getAttribute('aria-selected') === 'true') return 'subscribe';
      return 'subscribe';
    }

    if (option && option.getAttribute('aria-selected') === 'false') return 'was';
    return 'other';
  }

  function loadHandle(handle) {
    if (!handle || requestedHandles[handle] || typeof window.fetch !== 'function') return;
    requestedHandles[handle] = true;
    window
      .fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (!data || !data.variants) return;
        const map = pricesMap();
        data.variants.forEach((variant) => {
          const plans = {};
          (variant.selling_plan_allocations || []).forEach((allocation) => {
            plans[String(allocation.selling_plan_id)] = allocation.price;
          });
          map[variant.id] = {
            priceCents: variant.price,
            compareAtCents: variant.compare_at_price || 0,
            plans,
          };
        });
        document.dispatchEvent(new CustomEvent('bw-dental-prices-ready'));
      })
      .catch(() => {});
  }

  function init(buyBox) {
    if (buyBox.dataset.bwDentalPrice === '1') return;
    buyBox.dataset.bwDentalPrice = '1';

    let applying = false;
    let debounceTimer = null;

    function applyPrices() {
      applying = true;
      const qty = getQty(buyBox);
      syncQtyInputs(buyBox, qty);

      getPriceElements(buyBox).forEach((el) => {
        const container = el.closest('[data-replo-product-container]');
        const units = unitsFromContainer(container);
        if (!units) return;

        const kind = classify(el);
        let amount = null;
        if (kind === 'onetime' || kind === 'was') amount = units.onetime * qty;
        else if (kind === 'subscribe') amount = units.subscribe * qty;
        if (amount == null) return;

        const next = formatMoney(amount);
        if (el.textContent.trim() !== next) el.textContent = next;
      });

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          applying = false;
        });
      });
    }

    function scheduleApply() {
      if (applying) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(applyPrices, 40);
    }

    const qtyDisplay = buyBox.querySelector(`[data-rid="${QTY_DISPLAY_RID}"]`);
    if (qtyDisplay) {
      new MutationObserver(scheduleApply).observe(qtyDisplay, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    buyBox.addEventListener(
      'click',
      (event) => {
        if (
          event.target.closest(
            '[data-replo-increase-product-quantity], [data-replo-decrease-product-quantity]'
          )
        ) {
          scheduleApply();
          setTimeout(applyPrices, 80);
          setTimeout(applyPrices, 250);
          return;
        }

        if (event.target.closest('[role="tab"], [role="option"], [data-replo-tabs-trigger]')) {
          scheduleApply();
          setTimeout(applyPrices, 120);
          setTimeout(applyPrices, 400);
        }
      },
      true
    );

    new MutationObserver((mutations) => {
      if (applying) return;
      const relevant = mutations.some((m) => {
        const text = (m.target.textContent || '').trim();
        return looksLikeMoney(text) || /e[+-]?\d+/i.test(text) || text === '';
      });
      if (relevant) scheduleApply();
    }).observe(buyBox, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    document.addEventListener('bw-dental-prices-ready', scheduleApply);

    applyPrices();
  }

  function start() {
    const buyBox = getBuyBox();
    if (!buyBox) return false;
    buyBox.querySelectorAll('[data-replo-product-container]').forEach((container) => {
      const handle = container.getAttribute('data-replo-product-handle');
      const ctx = readForm(container);
      if (ctx && !pricesMap()[ctx.variantId]) loadHandle(handle);
    });
    init(buyBox);
    return true;
  }

  function boot() {
    if (start()) return;
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (start() || attempts >= 40) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
